import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/app/layouts";
import { ProtectedRoute } from "@/app/routes/protected";
import { NotFoundPage } from "@/components/common";
import { PATHS } from "@/lib/router";
import { authRoutes } from "@/features/auth";
// Each feature's *Routes array is imported straight from its routes.jsx,
// not the feature's top-level barrel (@/features/x). The barrel re-exports
// components/stores/services too, so importing through it would statically
// pull the whole feature into the eager bundle and defeat the React.lazy()
// page splitting done inside each routes.jsx.
import { dashboardRoutes } from "@/features/dashboard/routes";
import { esgDashboardRoutes } from "@/features/esg-dashboard-v3/routes";
import { benchmarkDashboardRoutes } from "@/features/benchmark-dashboard/routes";
import { userManagementRoutes } from "@/features/user-management/routes";
import { companyRoutes } from "@/features/company/routes";
import { organizationRoutes } from "@/features/organization/routes";
import { onboardingRoutes } from "@/features/onboarding/routes";
import { moreSolutionsRoutes } from "@/features/more-solutions/routes";
import { activityLogRoutes } from "@/features/activity-log/routes";
import { settingsRoutes } from "@/features/settings/routes";
import { surveysRoutes, surveysPublicRoutes } from "@/features/surveys/routes";
import { notificationsRoutes } from "@/features/notifications/routes";
import { esgPublicRoutes, esgRoutes } from "@/features/esg/routes";
import { dataEntryRoutes } from "@/features/data-entry/routes";
import { targetSetupRoutes } from "@/features/target-setup/routes";
import { carbonInventoryRoutes } from "@/features/carbon-inventory/routes";
import { billOcrRoutes } from "@/features/bill-ocr/routes";
import { customFrameworkRoutes } from "@/features/custom-framework/routes";
import { RouteGuard } from "./route-guard";
import { gElementRoutes } from "@/features/g-element/routes";
import {
  surveyLibraryPublicRoutes,
  surveyManagementRoutes,
} from "@/features/survey-management/routes";
import { callForHelpRoutes } from "@/features/call-for-help/routes";

// Compose all feature routes
const routes = [
  ...authRoutes,
  ...surveysPublicRoutes,
  ...esgPublicRoutes,
  ...surveyLibraryPublicRoutes,
  {
    element: (
      <ProtectedRoute>
        <RouteGuard>
          <AppLayout />
        </RouteGuard>
      </ProtectedRoute>
    ),
    children: [
      ...dashboardRoutes,
      ...esgDashboardRoutes,
      ...benchmarkDashboardRoutes,
      ...userManagementRoutes,
      ...companyRoutes,
      ...organizationRoutes,
      ...onboardingRoutes,
      ...moreSolutionsRoutes,
      ...settingsRoutes,
      ...activityLogRoutes,
      ...notificationsRoutes,
      ...surveysRoutes,
      ...esgRoutes,
      ...dataEntryRoutes,
      ...targetSetupRoutes,
      ...carbonInventoryRoutes,
      ...billOcrRoutes,
      ...customFrameworkRoutes,
      ...gElementRoutes,
      ...surveyManagementRoutes,
      ...callForHelpRoutes,
    ],
  },
  {
    path: PATHS.NOT_FOUND,
    element: <NotFoundPage />,
  },
];

// Create router instance
export const router = createBrowserRouter(routes);
